/*
 * @Author: Dom
 * @Date: 2022-05-29 17:42:16
 * @LastEditTime: 2022-06-05 14:06:12
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\services\upload.ts
 */
import request from '@/utils/request'
import { ImageUrlParams } from './data.d'

export async function uploadFile(params:any): Promise<any>{
    return request({
        url: '/seller/v1/file/upload',
        method: 'POST',
        data: params
    })
}

export async function getImgUrl(params:ImageUrlParams): Promise<any>{
    return request({
        url: '/seller/v1/file/info',
        method: 'get',
        params
    })
}

export async function importSku(params:any): Promise<any>{
    return request({
        url: '/seller/v1/sku/importSku',
        method: 'POST',
        data: params
    })
}

export async function batchImport(params:any): Promise<any>{
    return request({
        url: '/seller/v1/order/batchImportOrder',
        method: 'POST',
        data: params
    })
}
